<script type="text/jsx">
    export default {
        props: {
            isLowerCaseAllowed: {
                type: String, // hack: Boolean `false` from parent does not override `true` being set here
                default: () => 'yes'
            }
        },
        methods: {
            withAnyKeyDown: function (event) {
                var eventCode = event.code || '', eventKey = event.key || '';
                if (eventCode.startsWith('Key') || eventKey.length == 1) {
                    if ('ctrlKey' in event && event.ctrlKey == true) {
                        if ('key' in event && 'zxcv'.indexOf(event.key.toLowerCase()) !== -1) {
                            return;
                        }
                    }
                    if ('shiftKey' in event) {
                        var before = event.key;
                        var after = event.shiftKey && this.isLowerCaseAllowed === 'yes' ?
                            before.toLowerCase() :
                            before.toUpperCase();
                    
                        var srcEl = event.srcElement || event.originalTarget || {}; // hello, Firefox
                        var selStart = srcEl.selectionStart, selEnd = srcEl.selectionEnd;

                        var oldValue = event.target.value;
                        var head = oldValue.substr(0, selStart);
                        var tail = oldValue.substr(selEnd);

                        var newValue = [head, after, tail].join('');
                        if (newValue.length <= event.target.getAttribute('maxlength')) {
                            event.target.value = newValue;
                            srcEl.selectionStart = srcEl.selectionEnd = selStart + 1;
                        }
                        event.preventDefault();
                        // event.stopPropagation();
                    }
                }
            },
            withInput: function (event) {
                if (event.type == 'input') {
                    event.target.value = event.target.value.substring(0, event.target.getAttribute('maxlength')).toUpperCase();
                }
            },
            withAnyKeyUp: function (event) {
                this.updateInscription({ id: event.target.id, text: event.target.value });
            },
            // stub function
            updateInscription: function (data) {
                console.log('InscriptionEdit: override this function in the component using this mixin!');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// inscription-edit.vue?54a7e910